import { NavigationItem } from '@toolpad/core/AppProvider';

export const navigationItems = () => {
  const items: NavigationItem[] = [];
  items.push({ kind: 'header', title: 'アプリケーション' });
  return items;
};
